import uniqid from 'uniqid';

const GenerateUniqueFilename = async () => {
    return `${uniqid()}.jpg`;
};

export default GenerateUniqueFilename;